export default __webpack_public_path__ + "static/financial-info-group-4896d80f006e6d4fe853ff4b6b0e3b6b.png";